
















import Vue from 'vue';
import debounce from 'lodash/debounce';
import Color from '../../utils/Color';

export default Vue.extend({
  name: 'HubColorPicker',

  inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      required: true,
    },
  },

  computed: {
    color: {
      get() { return Color.formatColor(this.value); },
      set: debounce(
        function fn(this: Vue, color: string) {
          this.$emit('input', color);
        }, 300,
      ),
    },
  },
});
